/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Standard refusal reason for a rejected compliance document.
 * @export
 */
export const RefusalReasonType = {
    DocumentDoNotMatchUserData: 'DOCUMENT_DO_NOT_MATCH_USER_DATA',
    DocumentHasExpired: 'DOCUMENT_HAS_EXPIRED',
    DocumentIncomplete: 'DOCUMENT_INCOMPLETE',
    DocumentNotAccepted: 'DOCUMENT_NOT_ACCEPTED',
    DocumentUnreadable: 'DOCUMENT_UNREADABLE',
    Other: 'OTHER',
    BusinessManagers: 'BUSINESS_MANAGERS',
    BusinessEmployeesDetected: 'BUSINESS_EMPLOYEES_DETECTED',
    BusinessPersonalSwornStatement: 'BUSINESS_PERSONAL_SWORN_STATEMENT',
    SoletraderRegistrationOlderSixMonths: 'SOLETRADER_REGISTRATION_OLDER_SIX_MONTHS',
    InadequateSiret: 'INADEQUATE_SIRET',
    LegalStatusMismatch: 'LEGAL_STATUS_MISMATCH'
} as const;
export type RefusalReasonType = typeof RefusalReasonType[keyof typeof RefusalReasonType];


export function instanceOfRefusalReasonType(value: any): boolean {
    for (const key in RefusalReasonType) {
        if (Object.prototype.hasOwnProperty.call(RefusalReasonType, key)) {
            // @ts-ignore
            if (RefusalReasonType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RefusalReasonTypeFromJSON(json: any): RefusalReasonType {
    return RefusalReasonTypeFromJSONTyped(json, false);
}

export function RefusalReasonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefusalReasonType {
    return json as RefusalReasonType;
}

export function RefusalReasonTypeToJSON(value?: RefusalReasonType | null): any {
    return value as any;
}

